
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import classes from './NavigationTop.module.scss';
import { useTranslation } from 'react-i18next';


export const NavigationTop = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [isLanguageReady, setIsLanguageReady] = useState(false);
  
  // パスから期待される言語を取得
  const pathSegments = location.pathname.split('/').filter(segment => segment !== '');
  const expectedLanguage = pathSegments[0] || 'ja';
  
  useEffect(() => {
    // i18nの言語変更を監視
    const handleLanguageChange = (lng: string) => {
      if (lng === expectedLanguage) {
        setIsLanguageReady(true);
      }
    };
    
    // 初期状態をチェック
    if (i18n.language === expectedLanguage) {
      setIsLanguageReady(true);
    }
    
    // イベントリスナーを追加
    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [expectedLanguage]);
  
  // 言語が準備できていない場合は待機
  if (!isLanguageReady) {
    return null;
  }
  return (
    <nav className={classes.headerBar}>
      <div className={classes.hadoLogo}><Link to={t('common:header.logo_url')}><img src="https://hado-official.com/wp-content/themes/hado-official-theme/assets/img/common/logo.png"alt="Logo" /></Link></div>
      <ul className={`${classes.navMenu}`}>
      <li className={classes.navItem}><Link to={t('common:header.hado_url')}>{t('common:header.hado')}</Link></li>
        <li className={classes.navItem}><Link to={t('common:header.news_url')}> {t('common:header.news')}</Link></li>
        <li className={classes.navItem}><Link to={t('common:header.shop_url')}> {t('common:header.shop')}</Link></li>
        <li className={`${classes.navItem} ${classes.jpOnly}`}><Link to="https://hado-official.com/tournament/"> {t('common:header.tournament')}</Link></li>
        <li className={`${classes.navItem} ${classes.jpOnly}`}><Link to="https://hado-official.com/service/event/"> {t('common:header.business')}</Link></li>
        <li className={`${classes.navItem} ${classes.jpOnly}`}><Link to={t('common:header.channel_url')}> {t('common:header.channel')}</Link></li>
        <li className={`${classes.navItem} ${classes.jpOnly}`}><Link to="https://hado-official.stores.jp/?category_id=6118d6392b2d3d1f50766b92" target='_blank'>{t('common:header.store')}</Link></li>
        <li className={`${classes.navItem} ${classes.enOnly}`}><Link to="https://hado-official.com/en/forbusiness/"> {t('common:header.business')}</Link></li>
      </ul>
      
      
    </nav>
  );
};









